import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
	AuthenticationResponseSet,
	AuthenticationResultCode
} from '@shure/shared/angular/data-access/device-authentication';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { AuthenticationDevice } from '@shure/shared/angular/features/device-authentication/data-access';

@Injectable()
export class DeviceAuthenticationStub {
	public authenticationDevices$(deviceIds: string[]): Observable<AuthenticationDevice[]> {
		return of(
			deviceIds.map<AuthenticationDevice>((id) => ({
				id: id,
				model: DeviceModel.UNKNOWN,
				name: 'UNKNOWN',
				virtual: false,
				features: {}
			}))
		);
	}

	public setupPasswordForDevices(_deviceIds: string[], _password: string): Observable<boolean> {
		return of(true);
	}

	public setupWithoutAuthenticationForDevices(_deviceIds: string[]): Promise<boolean> {
		return Promise.resolve(true);
	}

	public updatePasswordForDevices(_deviceIds: string[], _password: string): Promise<boolean> {
		return Promise.resolve(true);
	}

	public removePasswordFromDevices(_deviceIds: string[]): Observable<boolean> {
		return of(true);
	}

	public clearPasswordFromDevice(_deviceId: string): Observable<boolean> {
		return of(true);
	}

	public authenticate(_deviceIds: string[], _password: string): Observable<AuthenticationResponseSet> {
		return of(<AuthenticationResponseSet>{ deviceResponses: [], response: AuthenticationResultCode.Ok });
	}

	public verify(_deviceIds: string[], _password: string): Observable<AuthenticationResponseSet> {
		return of(<AuthenticationResponseSet>{ deviceResponses: [], response: AuthenticationResultCode.Ok });
	}
}
